import React from 'react';
import {Card, Col, Container, Row} from 'react-bootstrap';
import './home.scss';
import '../layout/main.scss';
import oe_logo from '../../images/oe_logo.png';
import sp_sog from '../../images/sp-sog.png';
import cl_tookan from '../../images/cl-tookan.png';
import troycard from '../../images/TROYGRUN.jpg';


function Home() {
    return (
        <div className="App">
            <div className="home">
                <Container>
                    <div className="banner">
                        <div className="banContent">
                            <img src={oe_logo} alt="Orb Explorer"/>
                            <h3>Your NFT Browser</h3>
                            <p>Ethereum, Counterparty, Kusama, Klaytn</p>
                        </div>
                    </div>
                    <div className="mn-blocks home-spotlight">
                        <h4>Spotlight</h4>
                        <Row xs={1} sm={2} md={3} className="g-4">
                            {Array.from({ length: 3 }).map((_, idx) => (
                                <Col>
                                    <Card className="cards">
                                        <Card.Img variant="top" src={sp_sog} />
                                        <Card.Body>
                                            <h5>Spells of Genesis</h5>
                                            <hr/>
                                            <Card.Text>
                                                This is a longer card with supporting text below as a natural
                                                lead-in to additional content.
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    <div className="mn-blocks home-collection">
                        <div className="mn-block-title">
                            <h4>Selected collections</h4>
                            <span><a>View more</a></span>
                        </div>
                        <Row sm={1} md={2} lg={3} className="g-4">
                            {Array.from({ length: 6 }).map((_, idx) => (
                                <Col>
                                    <div className="cards cardCol">
                                        <img src={cl_tookan} alt="" />
                                        <div className="card-block">
                                            <h5 className="card-title">Crypto Kitties</h5>
                                            <hr/>
                                            <p>Blockchain-based project & all. Just a little presentation.</p>
                                            <a href="/Collection" >View collection</a>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                    <div className="mn-blocks home-asset">
                        <div className="mn-block-title">
                            <h4>Browse assets</h4>
                            <span><a>View more</a></span>
                        </div>
                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                            {Array.from({ length: 8 }).map((_, idx) => (
                                <Col>
                                    <Card className="cards cardAsset">
                                        <Card.Img variant="top" src={troycard} />
                                        <Card.Body>
                                            <h5>TROYGRUN</h5>
                                            <h6>Spells of genesis</h6>
                                            <hr/>
                                            <div className="clearfix">
                                                <span style={{float: 'left'}}>Issuance date:</span>
                                                <span style={{float: 'right'}}>06.03.2016</span>
                                            </div>
                                            <div className="clearfix">
                                                <span style={{float: 'left'}}>Nb issued:</span>
                                                <span style={{float: 'right'}}>300</span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default Home;
